import type { Candidate } from "./types";

export type QueueSort = "newest" | "oldest";

function timestamp(value?: string): number {
  if (!value) return 0;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function activityTimestamp(candidate: Candidate): number {
  return Math.max(timestamp(candidate.lastMessageAt), timestamp(candidate.dealUpdatedAt));
}

export function sortCandidates(candidates: Candidate[], direction: QueueSort = "newest"): Candidate[] {
  return [...candidates].sort((left, right) => {
    const delta = activityTimestamp(right) - activityTimestamp(left);
    if (delta !== 0) return direction === "newest" ? delta : -delta;
    return left.name.localeCompare(right.name, "ru");
  });
}
